import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import type { DrillSelector } from '../../api/drilldown';
import DrilldownModal from './DrilldownModal';

interface Ctx {
  /** Open the drill-down modal for the given selector. */
  open: (sel: DrillSelector) => void;
}

const DrilldownCtx = createContext<Ctx | null>(null);

export function DrilldownProvider({ children }: { children: ReactNode }) {
  const [selector, setSelector] = useState<DrillSelector | null>(null);

  const open = useCallback((sel: DrillSelector) => setSelector(sel), []);
  const close = useCallback(() => setSelector(null), []);

  return (
    <DrilldownCtx.Provider value={{ open }}>
      {children}
      <DrilldownModal selector={selector} onClose={close} />
    </DrilldownCtx.Provider>
  );
}

export function useDrilldown(): Ctx {
  const ctx = useContext(DrilldownCtx);
  if (!ctx) throw new Error('useDrilldown must be used inside <DrilldownProvider>');
  return ctx;
}
